import { useQuery } from '@tanstack/react-query';

import { getVisitCheckStatus } from '@/services/main/rezept/visitCheckService';
import type { VisitCheckStatusResponse } from '@/types/visitCheck.types';

import { useClinicContext } from './useClinicContext';

/**
 * Polled status query for the 訪問データチェック progress dialog.
 *
 * - `enabled` controls whether polling is active (FE turns it on when the
 *   dialog opens, off after navigating to the result page).
 * - `refetchInterval` returns false once `done === true` to stop polling.
 */
export const useVisitCheckStatusQuery = (token: string | null, enabled: boolean) => {
  const { tenant, clinicNumber } = useClinicContext();

  return useQuery<VisitCheckStatusResponse>({
    queryKey: ['visit-check', 'status', token],
    queryFn: () => getVisitCheckStatus(tenant, clinicNumber, token as string),
    enabled: enabled && !!token,
    refetchInterval: query => {
      const data = query.state.data as VisitCheckStatusResponse | undefined;
      return data?.done ? false : 1000;
    },
    refetchIntervalInBackground: false,
    staleTime: 0,
    gcTime: 0,
  });
};

export default useVisitCheckStatusQuery;
